import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {filterTagType_template} from "./filterTagType_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {filterTag_template} from "./filterTag_template";
import { emaki_brand } from "../../utils/types/emaki_brand";

declare var ko: any;

enum HandlingType {
    ADD = 'add',
    UPDATE = 'updates',
}

export class tagTypesEdit_template extends vnTemplate {

    protected datePicker: filterSingleDate_template;
    public imagePicker: imagePicker_template;
    protected tagTypeFilter: filterTagType_template;
    public restrictionFilter: filterAutocomplete_template;
    protected tagFilter: filterTag_template;

    protected getTemplateHtml(): string {
        return /*html*/ `
           <div class="form-header">
                <h3 class="form-title" data-bind="if: id() == null">Add Tag Type</h3>
                <h3 class="form-title" data-bind="if: id() != null">Edit Tag Type</h3>
                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
           </div>

           <div class="w-form-body">
                <div class="form-body">
                    <div class="form-group row">
                        <label class="form-label">Name</label>

                        <!-- ko ifnot: brandId  -->
                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: name, enable: permissions()['tag_type_edit'].write">
                        <!-- /ko -->

                        <!-- ko if: brandId  -->
                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: name, enable: false">
                        <!-- /ko -->

                    </div>
                    <div class="form-group row">
                    <label class="form-label">Brand Ownership</label>
                        <!-- ko if: brandOwnerOptions() -->
                            <select id="brandOwnerId"
                                data-bind="
                                    options: brandOwnerOptions(),
                                    disable: !canUpdateBrandOwner(),
                                    optionsCaption: 'Choose a brand',
                                    optionsText: 'name',
                                    value: brandOwnerId(),
                                    optionsValue: 'id',
                                    event: { change: onChangeBrandOwner }
                                "
                            ></select>
                        <!-- /ko -->
                    </div>
                </div>
                <div class="form-body">
                    <div class="form-group row">
                        <label class="form-label">Product Schema.org Template</label>
                            <!-- ko ifnot: brandId  -->
                            <select id="productSchemaTemplateId" data-bind="options: productSchemaTemplate_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: productSchemaTemplateId, optionsValue: 'id', event: { change: onChangeSpecificationType }"></select>
                            <!-- /ko -->

                             <!-- ko if: brandId  -->
                            <select id="productSchemaTemplateId" data-bind="options: productSchemaTemplate_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: productSchemaTemplateId, optionsValue: 'id', enable: false"></select>
                             <!-- /ko -->
                    </div>
                    <div class="form-group row">
                        <label class="form-label">Dataset</label>
                            <!-- ko ifnot: brandId  -->
                            <select id="datasetId" data-bind="options: dataset_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: datasetId, optionsValue: 'id'"></select>
                            <!-- /ko -->

                             <!-- ko if: brandId  -->
                            <select id="datasetId" data-bind="options: dataset_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: datasetId, optionsValue: 'id', enable: false"></select>
                             <!-- /ko -->
                    </div>
                </div>
           </div>
           <div class="w-form-body" style="margin-top: -1.25rem">
                <div class="form-body full-width  no-border" style="position: relative;">
                    <strong class="form-sub-title">Specifications</strong>

                    <!-- ko ifnot: brandId  -->
                    <button id="add_specification" class="form-section-btn icon i-plus" data-bind="event: {click: onClickAddSpecification}, visible: permissions()['tag_type_edit'].write" type="button"></button>
                    <!-- /ko -->
               </div>
           </div>
           <div class="w-form-body">
                        <!-- ko if: brandId -->
                        <div class="form-body">
                            <div class="form-group row">
                            <!-- ko if: groupings().length > 0 -->
                                <div style="display: inline-flex; margin-left: 2% ; margin-bottom: 1.1%; flex-wrap: wrap; gap: 12px">
                                    <select id="" data-bind="options: groupings, optionsCaption: 'Choose an option', optionsText: 'name', value: selectedGrouping, optionsValue: 'id'"></select>
                                    <button type="button" data-bind="event: { click: onClickEnableAll  }" class="btn-form ">Enable All</button>
                                    <button type="button" data-bind="event: { click: onClickDisableAll  }" class="btn-form ">Disable All</button>
                                </div>
                            <!-- /ko -->
                        </div>
                        </div>
                        <div class="form-body">
                            <div class="form-group">
                            <!-- ko if: showResetOrderButton -->
                                <p class="form-text modify">The tag specification fields follow a brand specific order. This can be reset to follow the network order by clicking here.</p>
                                <button type="button" data-bind="event: { click: onClickResetOrder }" class="btn-form ">Reset Order</button>
                            <!-- /ko -->
                            <!-- ko ifnot: showResetOrderButton -->
                                <p class="form-text default">The tag specification fields follow the network order.</p>
                            <!-- /ko -->
                        </div>
                        </div>
                    <!-- /ko -->
            </div>

           <div class="w-form-body">
                <div class="form-body full-width">

                    <div id="spec_section" class="form-group  specification">
                        <table id="spec_section_list" class="list-action full-width" >
                            <thead>
                                <tr style="background-color: #8a8a8a">

                                    <th class="short"></th>
                                    <th><span>Field Name</span></th>
                                    <th><span>Type</span></th>
                                    <th><span>Position</span></th>
                                    <!-- ko if: groupings().length > 0 -->
                                    <th><span>Grouping</span></th>
                                    <!-- /ko -->
                                    <!-- ko ifnot: brandId -->
                                    <th style="width: 10rem;"><span>Action</span></th>
                                    <!-- /ko -->
                                    <!-- ko if: brandId -->
                                    <th><span>Available for Use</span></th>
                                    <!-- /ko -->
                                    <!-- ko if: brandId -->
                                    <th><span>Extra Data</span></th>
                                    <!-- /ko -->

                                </tr>
                            </thead>
                            <tbody data-bind="foreach: sortable"  class="drag-handles sortable">
                                <tr data-bind="css: { dragging: dragging },
                                       dragZone: { name: 'sortable',
                                         dragStart: $parent.dragStart,
                                         dragEnd: $parent.dragEnd
                                       },
                                       dragEvents: {
                                         accepts: 'sortable',
                                         dragOver: $parent.reorderSortable,
                                         data: { items: $parent.sortable, item: $data }
                                       }">

                                    <td class="drag-handle i-move short -align-center"><button type="button" class="btn only-icon icon i-drag"></button></td>
                                    <td><span class="" data-bind="text: value.label"></td>
                                    <td><span data-bind="text: value.dataType"></td>

                                    <!-- ko ifnot: $parent.brandId  -->
                                    <td class="align-center"><span data-bind="text: value.position"></span></td>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.brandId  -->
                                    <td class="align-center"><span data-bind="text: value.extra.position()"></span></td>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.groupings().length > 0 -->
                                    <td class="align-center"><span data-bind="text: value.grouping ? value.grouping.name : ''"></span></td>
                                    <!-- /ko -->
                                    <!-- ko if: $parent.brandId  -->
                                    <td class="align-center">
                                        <input type="checkbox" data-bind="checked: value.extra.isEnabled, attr: {id: 'isEnabled_' + $index()}"/>
                                        <label style="height: 2rem" class="icon i-check" data-bind="attr: {for: 'isEnabled_' + $index()}"></label>
                                    </td>
                                    <td class="align-center">
                                        <input type="number" name="ratingScale" id="ratingScale" class="input-text" data-bind="value: value.extra.ratingScale, disable: value.dataType !== 'rating', event: { input: function(data, event) { data.value.extra.ratingScale(data.value.extra.ratingScale().replace(/[^0-9]/g, '')); } }" />
                                    </td>
                                    <!-- /ko -->

                                    <!-- ko ifnot: $parent.brandId  -->
                                        <td class="w-btn align-center" data-bind="visible: $parent.permissions()['tag_type_edit'].write">
                                            <!-- ko ifnot: $data.value.isDataTypeJSON -->
                                                <button type="button" class="btn-form icon icon-only i-edit" data-bind="event: {click: $parent.onClickEditSpecification.bind($index) }"></button>
                                            <!-- /ko -->
                                            <!-- ko if: $data.value.canDelete -->
                                                <button type="button" class="btn-form icon icon-only i-delete" data-bind="event: {click: $parent.onClickDeleteSpecification.bind($index) }"></button>
                                            <!-- /ko -->
                                        </td>
                                    <!-- /ko -->

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
           </div>
           <div class="form-footer">
                <button type="button" data-bind="event: { click: onClickCancel }" class="btn ">Cancel</button>
                <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>

           </div>

            <div data-bind="css: { 'is-visible': isAddSpecVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:50rem;">
                        <div class="form-header">
                            <h3 class="form-title" data-bind="text: popupTitle"></h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCancelSaveSpecification }"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group row">
                                <label class="form-label">Field Name</label>
                                <input type="text" class="input-text"  data-bind="event: { keyup: onNewFieldChange }, valueUpdate : ['afterkeydown','propertychange','input'], textInput: specificationLabel, enable: (permissions()['tag_type_field_label_edit'].write || permissions()['tag_type_field_label_edit'].update)">
                            </div>

                            <div class="form-group row">
                                <label class="form-label">Type</label>
                                <select id="" data-bind="options: specTypes_options, disable: idField(), optionsCaption: 'Choose an option', optionsText: 'name', value: selectedSpecType, optionsValue: 'id', event: { change: onChangeSpecificationType }"></select>
                            </div>
                            <div class="form-group" data-bind="visible: selectedSpecType() == 2 || selectedSpecType() == 3, enable: (permissions()['tag_type_field_label_edit'].write || permissions()['tag_type_field_label_edit'].update)">

                                ${ this.restrictionFilter.getHtmlBuild() }

                                <div class="form-group" data-bind="foreach: oldRestrictionTypeArray, css: { 'is-disable' : idField() }">
                                    <div class="btn-selection"><span data-bind="text: name + ' ' + formattedDataset"></span></div>
                                </div>
                                <div class="form-group" data-bind="foreach: restrictionTypeArray">
                                    <div class="btn-selection"><span data-bind="text: name"></span><button class="icon i-x-after" type="button" data-bind="event: { click: $parent.onClickDeleteRestrictionTypeArray }"></button></div>
                                </div>
                            </div>
                            <!-- ko if: groupings().length > 0 -->
                                <div class="form-group row">
                                    <label class="form-label">Grouping</label>
                                    <select id="" data-bind="options: groupings, optionsCaption: 'Choose an option', optionsText: 'name', value: selectedGrouping, optionsValue: 'id'"></select>
                                </div>
                            <!-- /ko -->
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelSaveSpecification }" class="btn ">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickSaveSpecification }, enable: ( selectedSpecType() && specificationLabel() &&  ( (selectedSpecType() != 2 && selectedSpecType() != 3) || restrictionTypeArray().length || oldRestrictionTypeArray().length ) ) " class="btn highlight">Apply</button>
                        </div>
                    </div>
                </div>
             </div>
            `;
    }

    protected initPartial(): void {

        this.datePicker = new filterSingleDate_template("datePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter = new filterTagType_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this);
        this.restrictionFilter = new filterAutocomplete_template("filterAutocompleteTagType_template", this.getTemplateViewModel(), this.caller);
        this.restrictionFilter.setPlaceholderAndLabel( 'Tag Restriction' );
    }

    public buildDatePickerCalendar() {

        this.datePicker.buildCalendar();
    }

    protected getTemplateName(): string {
        return "tagTypesEdit_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    protected buildViewModel(): any {

        let self = this;
        return {
            id: ko.observable(null),
            name: ko.observable(null),
            productSchemaTemplateId: ko.observable(null),
            type: ko.observable(null),
            datasetId: ko.observable(null),
            groupings: ko.observableArray([]),
            specificationLabel: ko.observable(null),
            specificationIsForcedOverwrite: ko.observable(false),
            specificationData: ko.observable(null),
            isAddSpecVisible: ko.observable(null),
            specEdited: ko.observable(null),
            showResetOrderButton: ko.observable(false),
            idField: ko.observable(null),
            fieldHandlingType: ko.observable(null),
            editedSpecPosition: ko.observable(null),
            resetActivated: ko.observable(false),
            popupTitle: ko.observable(null),
            isForcedOverwrite: ko.observable(null),
            disableAll: ko.observable(false),
            enableAll: ko.observable(true),
            toggleAllValue: ko.observable(""),
            sortable: ko.observableArray([]),
            productSchemaTemplate_options: ko.observableArray([]),
            dataset_options: ko.observableArray([]),
            specTypes_options: ko.observableArray([{id: 1, name: "Text"}, {id: 2, name: "Tag"}, {id: 3, name: "Tags"}, {id: 4, name: "Date"}, {id: 5, name: "Rich Text"}, {id: 6, name: "Currency"},{id: 7, name: "Number"}, {id: 8, name: "Rating"},{id: 9, name: "Images"}]),
            selectedSpecType: ko.observable(null),
            selectedGrouping: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['tag_type_edit', 'tag_type_field_label_edit', 'tag_type_edit_set_owned'])),
            brandId: ko.observable(undefined),
            restrictionTypeArray: ko.observableArray([]),
            oldRestrictionTypeArray: ko.observableArray([]),
            brandOwner: ko.observable(null), // was it set when we loaded it?
            brandOwnerId: ko.observable(null), // what is it set to now?
            tagTypeHasBrandOwner: ko.pureComputed(() => !!self.getTemplateViewModel().brandOwner()),
            brandOwnerOptions: ko.observableArray([]),
            canUpdateBrandOwner: ko.pureComputed(
                () => !self.getTemplateViewModel().tagTypeHasBrandOwner() // already has an owner
                    && !self.getTemplateViewModel().brandId() // only at the network level, should this be editable.
                    && self.getTemplateViewModel().permissions()['tag_type_edit_set_owned'] // gotta have the permissions
                    && self.getTemplateViewModel().permissions()['tag_type_edit_set_owned'].update // with update set to true.
            ),
            onClickSave: () => {
                self.onClickSave();
            },
            onClickCancel: () => {
                self.onClickCancel();
            },
            onChangeSpecificationType: () => {
                self.onChangeSpecificationType();
            },
            onChangeBrandOwner: (data,event) => self.onChangeBrandOwner(data,event),
            onClickAddSpecification: () => {
                self.onClickAddSpecification();
            },
            onClickSaveSpecification: () => {
                self.onClickSaveSpecification();
            },
            onClickCancelSaveSpecification: () => {
                self.onClickCancelSaveSpecification();
            },
            onClickEditSpecification: (value, data, event) => {
                self.onClickEditSpecification(value);
            },
            onClickDeleteSpecification: (value, data, event) => {
                self.onClickDeleteSpecification(value);
            },
            onClickRemoveSelectedTag: (data, event) => {
                self.onClickRemoveSelectedTag(data);
            },
            onClickResetOrder: () => {
                self.onClickResetOrder();
            },
            onClickEnableAll: (data,event) => {
              self.onClickEnableAll(data,event)
            },
            onClickDisableAll: (data,event) =>{
                self.onClickDisableAll(data,event)
            },
            dragStart: (data, event) => { self.startDrag(data, event); },
            dragEnd: (data) => { data.dragging(false); self.updatePositions() },
            reorderSortable: (event, dragData, zoneData) => { self.reorderSortable(event, dragData, zoneData); },
            onClickDeleteRestrictionTypeArray: function (data, event) {
                self.onClickDeleteRestrictionTypeArray(data);
            },
            onNewFieldChange: (data, evt) => {
                self.onNewFieldChange(data, evt);
            }
        };
    }

    public getDatasetID(): number {

        return this.getTemplateViewModel().id();
    }

    public setBrandOptions = (brands: emaki_brand[]): void => {
        this.getTemplateViewModel().brandOwnerOptions(brands);
    };

    public setBrandOwner = (brand: emaki_brand|null): void => {
        this.getTemplateViewModel().brandOwner(brand);
        this.getTemplateViewModel().brandOwnerId(brand? brand.id : null);
    }

    public getViewModelForRequest() {

        return {
            idTagType: this.getTemplateViewModel().id(),
            name: this.getTemplateViewModel().name(),
            productSchemaTemplateId: this.getTemplateViewModel().productSchemaTemplateId(),
            datasetId: this.getTemplateViewModel().datasetId(),
            idBrandOwner: this.getTemplateViewModel().brandOwnerId(),
            specifications: this.getSpecifications(),
            resetActivated: this.getTemplateViewModel().resetActivated(),
            lockItem: true
        };
    }

    public getSpecifications() {

        let specs = [];
        let sortable = this.getTemplateViewModel().sortable();

        sortable.forEach((s) => specs.push(s.value));
        console.log('sortable', sortable);

        return specs;
    }
    public onClickSave() {

        this.caller.saveTagType();
    }

    public onClickCancel() {
        this.caller.cancel();
    }

    protected onClickAddSpecification() {

        this.getTemplateViewModel().isAddSpecVisible(true);
        this.getTemplateViewModel().popupTitle('Add Specification');
        this.getTemplateViewModel().fieldHandlingType(HandlingType.ADD);

    }

    protected onClickEditSpecification(data) {

        this.getTemplateViewModel().fieldHandlingType(HandlingType.UPDATE);
        this.caller.getTagTypes(data.value.typeRestrictions, "getTagTypes");
        this.caller.getTagTypes(data.value.oldTypeRestrictions, "getOldTagTypes");
        this.getTemplateViewModel().isAddSpecVisible(true);
        this.getTemplateViewModel().popupTitle('Edit Specification');
        this.getTemplateViewModel().specEdited(data.value);
        this.getTemplateViewModel().idField(data.value.id);
        this.getTemplateViewModel().editedSpecPosition(data.value.position);
        //selectedGrouping
        // this.getTemplateViewModel().specificationIsForcedOverwrite(obj.isForcedOverwrite);
        let selectedSpecType = this.getTemplateViewModel().specTypes_options().find(c => {
            let dataType = data.value.dataType;
            if (dataType) {

                return c.name.toLowerCase() == dataType.toLowerCase();
            }
        });

        let selectedGroupType = this.getTemplateViewModel().groupings().find(c => {
            let dataType = data.value.dataType;
            if (dataType) {

                return c.name.toLowerCase() == dataType.toLowerCase();
            }
        });

        if(data.value.grouping){

            let selectedGroup = this.getTemplateViewModel().groupings().find(c => {
                let group = data.value.grouping.name;
                if (group) {

                    return c.name.toLowerCase() == group.toLowerCase();
                }
            });
            this.getTemplateViewModel().selectedGrouping(selectedGroup.id);
        }
        if(selectedSpecType) {
            this.getTemplateViewModel().selectedSpecType(selectedSpecType.id);
        }
        this.getTemplateViewModel().specificationLabel(data.value.label);
    }

    protected onClickCancelSaveSpecification() {
        this.clearSpecEditForm();
    }

    public onClickEnableAll(data,event) {

        let sortable = this.getTemplateViewModel().sortable();
        let selectedItem = this.getTemplateViewModel().selectedGrouping();

        if(selectedItem){

            sortable.forEach(item =>{

                if(item.value.grouping){
                    if(item.value.grouping.id == selectedItem){
                        item.value.extra.isEnabled = true;
                    }
                }
            });

            this.getTemplateViewModel().sortable([]);
            this.getTemplateViewModel().sortable(sortable);
        }else{
            throw new Error("You need to select an Option");
        }
    }

    public onClickDisableAll(data,event){
        let sortable = this.getTemplateViewModel().sortable();
        let selectedItem = this.getTemplateViewModel().selectedGrouping();

        if(selectedItem){

            sortable.forEach(item =>{

                if(item.value.grouping){
                    if(item.value.grouping.id == selectedItem){
                        item.value.extra.isEnabled = false;
                    }
                }
            });

            this.getTemplateViewModel().sortable([]);
            this.getTemplateViewModel().sortable(sortable);
        }else{
            throw new Error("You need to select an Option");
        }
    }

    protected onClickSaveSpecification() {
        let type = null;
        let selectedSpecType = this.getTemplateViewModel().specTypes_options().find(e => (e.id == this.getTemplateViewModel().selectedSpecType()))
        type = selectedSpecType.name;

        let idField = null;
        if (this.getTemplateViewModel().specEdited()) {
            idField = this.getTemplateViewModel().specEdited().id;
        }

        let addedSpecNames = this.getTemplateViewModel().sortable().map((s) => String(s.value.label).trim());

        let restrictionTypeArray = this.getTemplateViewModel().restrictionTypeArray();
        let oldRestrictionTypeArray = this.getTemplateViewModel().oldRestrictionTypeArray();

        if (!this.isBrand()) {

            this.caller.validateTagSpec(
                idField,
                this.getTemplateViewModel().id(),
                this.getTemplateViewModel().specificationLabel(),
                type.name,
                restrictionTypeArray,
                oldRestrictionTypeArray,
                addedSpecNames
            );
        }
    }

    private clearSpecEditForm(){

        this.getTemplateViewModel().isAddSpecVisible(false);
        this.getTemplateViewModel().selectedSpecType(null);
        this.getTemplateViewModel().specificationLabel(null);
        this.getTemplateViewModel().isAddSpecVisible(false);
        this.getTemplateViewModel().popupTitle(null);
        // this.getTemplateViewModel().specificationIsForcedOverwrite(false);
        this.getTemplateViewModel().idField(null);
        this.getTemplateViewModel().editedSpecPosition(null);
        this.getTemplateViewModel().specEdited(null);
        this.getTemplateViewModel().fieldHandlingType(null);
        this.getTemplateViewModel().selectedGrouping(null);
        this.restrictionFilter.clearEverything();
        this.getTemplateViewModel().restrictionTypeArray([]);
        this.caller.removeErrorMessagePanel();
    }

    public addSpecification() {

        let fieldHandlingType = this.getTemplateViewModel().fieldHandlingType();

        switch (fieldHandlingType) {
            case HandlingType.ADD:
                this.addNewSpecification();
                break;
            case HandlingType.UPDATE:
                this.updateSpecification();
                break;
            default:
                break;
        }

        this.clearSpecEditForm();
    }

    public addNewSpecification(): void {

        let sortable = this.getTemplateViewModel().sortable();
        let editedFieldId = this.getTemplateViewModel().idField();

        let type = null;
        let selectedSpecType = this.getTemplateViewModel().specTypes_options().find(e => (e.id == this.getTemplateViewModel().selectedSpecType()));
        let groupingEdited = this.getTemplateViewModel().groupings().find(e => (e.id == this.getTemplateViewModel().selectedGrouping()));
        type = selectedSpecType.name;

        let restrictionsIds = [];
        if(this.getTemplateViewModel().restrictionTypeArray().length>0){
            this.getTemplateViewModel().restrictionTypeArray().forEach(restriction=>{
                restrictionsIds.push(restriction.id);
            })
        }

        let specToAdd = {
            id: editedFieldId,
            isAdded: true,
            label: this.getTemplateViewModel().specificationLabel(),
            dataType: type,
            grouping: groupingEdited,
            canDelete: (!editedFieldId),
            typeRestrictions: restrictionsIds,
            isSelected: true,
            position: sortable.length + 1,
        };


        sortable.push({
            value: specToAdd,
            dragging: ko.observable(false),
            isSelected: ko.observable(false)
        });
        this.getTemplateViewModel().sortable(sortable);
    }

    public updateSpecification(): void {

        let specEdited = this.getTemplateViewModel().specEdited();
        let editedSpecPosition = this.getTemplateViewModel().editedSpecPosition();
        let editedFieldId = this.getTemplateViewModel().idField();

        let type = null;
        let selectedSpecType = this.getTemplateViewModel().specTypes_options().find(e => (e.id == this.getTemplateViewModel().selectedSpecType()))
        let groupingEdited = this.getTemplateViewModel().groupings().find(e => (e.id == this.getTemplateViewModel().selectedGrouping()));
        type = selectedSpecType.name;

        specEdited['label'] = this.getTemplateViewModel().specificationLabel();
        specEdited['dataType'] = type;
        specEdited['grouping'] = groupingEdited;
        let restrictionsIds = [];
        if(this.getTemplateViewModel().restrictionTypeArray().length>0){
            this.getTemplateViewModel().restrictionTypeArray().forEach(restriction=>{
                restrictionsIds.push(restriction.id);
            })
        }
        specEdited['typeRestrictions'] = restrictionsIds;

        restrictionsIds = [];
        if(this.getTemplateViewModel().oldRestrictionTypeArray().length>0){
            this.getTemplateViewModel().oldRestrictionTypeArray().forEach(restriction=>{
                restrictionsIds.push(restriction.id);
            })
        }
        specEdited['oldTypeRestrictions'] = restrictionsIds;

        let sortable = this.getTemplateViewModel().sortable();
        let rebuildSortables = [];
        sortable.forEach((s) => {
            let buildSortable = s;
            if (s.value.position == editedSpecPosition) {
                buildSortable = {
                    value: specEdited,
                    dragging: ko.observable(false),
                    isSelected: ko.observable(false)
                };
            }

            rebuildSortables.push(buildSortable);
        });

        this.getTemplateViewModel().sortable(rebuildSortables);
    }

    public setId(id): void {

        this.getTemplateViewModel().id(id);
    }

    public setName(name): void {

        this.getTemplateViewModel().name(name);
    }

    public setProductSchemaTemplateId(id): void {

        this.getTemplateViewModel().productSchemaTemplateId(id);
    }

    public setDatasetId(id): void {

        this.getTemplateViewModel().datasetId(id);
    }


    public setSlug(name): void {

        this.getTemplateViewModel().slug(name);
    }

    public setHasSlug(hasSlug): void {

        this.getTemplateViewModel().hasSlug(hasSlug);
    }

    public setTagType(tagType): void {
        this.getTemplateViewModel().tagType(tagType)
        this.tagTypeFilter.setTagTypeInfo(tagType);
        this.getTemplateViewModel().brandOwner(tagType.brandOwner? tagType.brandOwner : null);
    }

    public setIdTagType(idTagType): void {

        this.getTemplateViewModel().idTagType(idTagType);
    }

    public setDescription(description): void {

        this.getTemplateViewModel().description(description);
    }

    public setIsTagSelectable(isTagSelectable): void {

        this.getTemplateViewModel().isTagSelectable(isTagSelectable);
    }

    public setSpecifications(specifications): void {

        specifications.forEach((specification) => {

            if (this.isBrand()) {
                specification.extra.position = ko.observable(specification.extra.position);
                //init ratingScale
                specification.extra.ratingScale = null;
                if(specification.extra.extraData && specification.extra.extraData.ratingScale) {
                    specification.extra.ratingScale = specification.extra.extraData.ratingScale;
                }
                if (specification.extraData && specification.extraData.ratingScale) {
                    specification.ratingScale = ko.observable(specification.extraData.ratingScale);
                    if (!specification.extra.ratingScale) {
                        specification.extra.ratingScale = specification.ratingScale;
                    }
                }
            } else {
                specification.position = ko.observable(specification.position);
                specification.ratingScale = ko.observable(
                    specification.extraData && specification.extraData.ratingScale?
                        specification.extraData.ratingScale : null
                );
            }

            specification.oldTypeRestrictions = specification.typeRestrictions;
            specification.typeRestrictions = [];
        });

        let x = this.toDraggables(specifications);
        this.getTemplateViewModel().sortable([]);
        this.getTemplateViewModel().sortable(x);
        this.detectOrderStatus(specifications);
        console.log('specs', specifications);

    }

    private detectOrderStatus(specifications): void {

        let showResetOrderButton = false;
        if (this.isBrand()) {
            //All follow the same. If first item has position null it's following network order
            //If not custom order. Extra table holds all the same
            for(let i =0; i<specifications.length; i++){
                if(specifications[i].position !== specifications[i].extra.position()){
                    showResetOrderButton = true;
                    break;
                }
            }
        }
        this.getTemplateViewModel().showResetOrderButton(showResetOrderButton);
    }

    public setTagTypes(tagTypes): void {

        this.getTemplateViewModel().tagType_options(tagTypes);
    }

    public setTagOptions(tags): void {

        this.getTemplateViewModel().tag_options(tags);

        if (this.getTemplateViewModel().editedSelectedTags()) {
            if (this.getTemplateViewModel().editedSelectedTags().length == 1) {
                this.getTemplateViewModel().selectedTag(this.getTemplateViewModel().editedSelectedTags()[0])
            } else {
                this.getTemplateViewModel().selectedTags(this.getTemplateViewModel().editedSelectedTags())
            }
        }
    }

    public setProductSchemaTemplateOptions(templates): void {

        this.getTemplateViewModel().productSchemaTemplate_options(templates);
    }

    public setDatasetOptions(templates): void {

        this.getTemplateViewModel().dataset_options(templates);
    }



    protected setTagTypeFilter(idElement, tagTypes): void  {

        this.getTemplateViewModel()[idElement].tagTypes(tagTypes);
    }

    public onChangeSpecificationType() {

        this.getTemplateViewModel().specificationData('');
    }

    public onChangeBrandOwner = (_:any, event: any) => this.getTemplateViewModel().brandOwnerId(event.target.value);

    protected onClickDeleteSpecification(data) {

        let indexSortable = this.getTemplateViewModel().sortable().findIndex(element => (element.value.label == data.value.label));
        if (indexSortable > -1) {
            this.getTemplateViewModel().sortable.splice(indexSortable, 1);
        }
    }

    private getSpecs(tagFields, values) {
        let specs = [];

        for (let i = 0; i < tagFields.length; i++) {
            let fieldDataType = tagFields[i].dataType;
            let dataType = null;
            let fieldData = null;
            if (fieldDataType == 'text') {
                dataType = {id: 1, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue ? fieldValue.value : '');
            } else if (fieldDataType == 'tag') {
                dataType = {id: 2, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue ? fieldValue.value : {});
            } else if (fieldDataType == 'tags') {
                dataType = {id: 3, name: fieldDataType};
                let fieldValue = values.filter(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue ? fieldValue : []);
            } else if (fieldDataType == 'date') {
                dataType = {id: 4, name: fieldDataType};
                let fieldValue = values.find(o => o.idField === tagFields[i].id);
                fieldData = (fieldValue ? fieldValue.value : '');
            }
            let spec = {
                id: tagFields[i].id,
                label: tagFields[i].label,
                data: fieldData,
                restriction: tagFields[i].restriction,
                type: dataType,
                isSelected: true,
                isAdded: false,
                isForcedOverwrite: tagFields[i].isForcedOverwrite
            };
            let sortable = {
                value: spec,
                dragging: ko.observable(false),
                isSelected: ko.observable(false)
            };
            specs.push(sortable)
        }

        return specs;
    }

    protected onClickEditTagImage(){

        let tagImage = this.getTemplateViewModel().tagImage();
        this.showImagePicker("single-select", "tagImage");
        this.imagePicker.editImage(tagImage);
    }

    protected onClickViewTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.add("is-viewing");
    }

    protected onClickCloseTagImage(){

        let tagImageElement = document.getElementById("tagImage");
        tagImageElement.classList.remove("is-viewing");
    }

    protected onClickAddTagImage(){

        this.showImagePicker("single-select", "tagImage");
    }

    public showImagePicker(mode,target){

        this.imagePicker.setMode(mode);
        this.imagePicker.setTarget(target);
        this.caller.getImageData();
        this.imagePicker.show();
    }

    public setTagImage(image){

        this.getTemplateViewModel().tagImage(image);
    }

    public onClickRemoveSelectedTag(data) {

        let index = this.getTemplateViewModel().editedSelectedTags().findIndex(element => (element.idValue == data.idValue));
        if (index > -1) {
            let selectedTags = this.getTemplateViewModel().editedSelectedTags();
            selectedTags.splice(index, 1);
            this.getTemplateViewModel().editedSelectedTags([]);
            this.getTemplateViewModel().editedSelectedTags(selectedTags);
        }
    }


    public onClickResetOrder() {

        let specs = this.getSpecifications();
        let newSpecs = [];

        specs.forEach((s) => {

            s.extra.position(s.position);
            newSpecs.push(s);
        });

        newSpecs.sort((a, b) => {
            return (a.extra.position() - b.extra.position());
        });

        this.getTemplateViewModel().resetActivated(true);
        this.setSpecifications(newSpecs);

        this.getTemplateViewModel().showResetOrderButton(false);
    }

    public addTag(){

        let tagObj = this.tagFilter.getTemplateViewModel().tagObj();

        if (tagObj != "") {
            if(this.getTemplateViewModel().selectedSpecType() == 3){
                let editedSelectedTags = this.getTemplateViewModel().editedSelectedTags();
                let index = editedSelectedTags.findIndex(el => (el.idValue == tagObj.id));
                if(index == -1) {
                    editedSelectedTags.push({idValue: tagObj.id, tag: tagObj});
                    this.getTemplateViewModel().editedSelectedTags([])
                    this.getTemplateViewModel().editedSelectedTags(editedSelectedTags)
                    this.tagFilter.clearInput();
                }
            }else if(this.getTemplateViewModel().selectedSpecType() == 2){
                this.getTemplateViewModel().selectedTag(tagObj)
            }
        }
    }

    public addTagType(){

        let tagTypeObj = this.tagTypeFilter.getTemplateViewModel().tagTypeObj();

        if (tagTypeObj != "") {
            this.getTemplateViewModel().tagType(tagTypeObj);
            this.getTemplateViewModel().sortable(this.getSpecs(tagTypeObj.fields, []))
        } else {
            this.getTemplateViewModel().tagType(null);
            this.getTemplateViewModel().sortable([])
        }
    }

    public setTagFilter(tags) {

        this.getTemplateViewModel().tagFilter.tags(tags);
    }

    public getTagsSuggestion(keyword, idElement) {

        let idTagType = this.getTemplateViewModel().restrictionFilter.idTagType();

        this.caller.getTagByType(idTagType, keyword);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }


    public startDrag(data, event){

        try{
            this.executeDrag(data, event);

        }catch(err){
            throw new Error(err.message);
        }
    }

    public executeDrag(data, event) {

        if (event.srcElement.className.indexOf('i-move') !== -1) {
            data.dragging(true);
            return true;
        } else {
            throw new Error('drag only allowed from the handle');
        }
    }

    /**
     * Handles dragstop event mainly to update adsSetups positions.
     *
     */
    public updatePositions(){

        let sortable = this.getTemplateViewModel().sortable();

        if(typeof sortable !== "undefined" && sortable !== null && Object.keys(sortable).length !== 0) {

            let currentPosition = 1;
            for(let currentSortable of sortable) {

                if (this.isBrand()) {

                    currentSortable.value.extra.position(currentPosition);
                } else {

                    currentSortable.value.position(currentPosition);
                }
                currentPosition++;
            }
        }

        this.getTemplateViewModel().resetActivated(false);
        this.getTemplateViewModel().showResetOrderButton(true);
    }

    private toDraggables(values) {
        return ko.utils.arrayMap(values, function (value) {
            return {
                value: value,
                dragging: ko.observable(false),
                isSelected: ko.observable(false)
            };
        });
    }

    public reorderSortable(event, dragData, zoneData): void{

        if(dragData !== zoneData.item){

            var zoneDataIndex = zoneData.items.indexOf(zoneData.item);

            zoneData.items.remove(dragData);
            zoneData.items.splice(zoneDataIndex, 0, dragData);
        }
    }

    public setBrandId(brandId?: number): void {

        this.getTemplateViewModel().brandId(brandId);
    }

    public getBrandId(): number {

        return this.getTemplateViewModel().brandId();
    }

    public isBrand(): boolean {

        return this.caller.isBrand();
    }

    public getGroupings () {
        return this.getTemplateViewModel().groupings();
    }

    public setGroupings (groupings) {
        this.getTemplateViewModel().groupings([]);
        this.getTemplateViewModel().groupings(groupings);
    }

    protected onClickDeleteRestrictionTypeArray(data) {
        let selectedRestrictionTypeArray = this.getTemplateViewModel().restrictionTypeArray();
        let index = selectedRestrictionTypeArray.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedRestrictionTypeArray.splice(index, 1);
        }

        this.getTemplateViewModel().restrictionTypeArray(selectedRestrictionTypeArray);
    }

    protected onNewFieldChange(data, evt) {

        let specificationLabel = String(this.getTemplateViewModel().specificationLabel()).trim();
        if (specificationLabel.length == 0) {

            this.getTemplateViewModel().specificationLabel(specificationLabel);
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypesEdit_template.ts